import { ARTIST_SAVE, ARTIST_NAME_SAVE } from '../app/constant'
import { ADMIN_CHANGE_ARTIST } from '../app/constant'

export const artistSave = (artists) => {
  return {
    type: ARTIST_SAVE,
    artists: artists
  }
}

export const artistNamesSave = (artistNames) => {
  return {
    type: ARTIST_NAME_SAVE,
    artistNames: artistNames
  }
}

export const adminChangeArtist = (info) => {
  return {
    type: ADMIN_CHANGE_ARTIST,
    info: info
  }
}
